import type { CustomerCardOptions } from '@makemydeal/dr-dash-types';
import { SHOW_CUSTOMER_CARD, SHOW_CUSTOMER_SEARCH } from '../actionTypes/customerUIActionTypes';

export const showCustomerCard = (show: boolean, options?: CustomerCardOptions) => ({
    type: SHOW_CUSTOMER_CARD,
    payload: { show, options }
});

export const showCustomerSearch = (show: boolean) => ({ type: SHOW_CUSTOMER_SEARCH, payload: show });
